module.exports = __webpack_public_path__ + "img/event.7963496.png";